// extracted by mini-css-extract-plugin
export var separator = "common-recipe-molecules-module--separator--cd450";
export var simpleView = "common-recipe-molecules-module--simple-view--138fb";
export var title = "common-recipe-molecules-module--title--8786c";